<template>
    <v-card elevation="0">
        <v-card v-if="model == null" height="20px" elevation="0">
            <v-progress-linear
                    color="red accent-4"
                    indeterminate
                    rounded
                    height="6"
            ></v-progress-linear>
        </v-card>
        <v-card v-else elevation="0">
            <v-card-actions class="ma-0 pa-0">
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-2">
                        <v-card-text class="ma-2 pa-0 grey--text"></v-card-text>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="white--text"
                                       elevation="0"
                                       color="green"
                                       v-bind="attrs"
                                       v-on="on"
                                       @click="onPressImportJson"> Import REWARDS Json
                                    <v-icon size="22" class="ml-2">mdi-database-import-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Import Json</span>
                        </v-tooltip>
                        <input ref="uploaderJson"
                               class="d-none"
                               type="file"
                               accept="application/JSON"
                               @change="onFileChangedJson">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="white--text ml-2"
                                       elevation="0"
                                       color="red"
                                       v-bind="attrs"
                                       v-on="on"
                                       @click="onPressImportFile">
                                    add file
                                    <v-icon size="22">mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Add file</span>
                        </v-tooltip>
                        <input ref="uploaderFile"
                               class="d-none"
                               type="file"
                               @change="onFileChangedFile">
                    </v-card-actions>
                </v-card>
            </v-card-actions>

            <v-card-actions class="ma-0 pa-0 mt-3">
                <v-progress-linear
                        v-if="working"
                        color="red accent-4"
                        indeterminate
                        rounded
                        height="6"
                ></v-progress-linear>
            </v-card-actions>

            <v-card-actions class="ma-0 pa-0 mt-3">
                <v-card outlined elevation="0" width="100%">
                    <v-data-table
                            style="width: 100%;"
                            fixed-header
                            :items="files"
                            :headers="headers"
                            hide-default-header
                            hide-default-footer
                            disable-pagination>
                        <template v-slot:item.size="{ item }">
                            <v-card-text>{{getSize(item.size)}}</v-card-text>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                            color="green"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mr-0"
                                            @click="onPressPreview(item)">
                                        <v-icon size="22">mdi-eye</v-icon>
                                    </v-btn>
                                </template>
                                <span>Preview File</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                           icon
                                           color="red"
                                           v-bind="attrs"
                                           v-on="on"
                                           class="mr-0"
                                           @click="onPressDelete(item)">
                                        <v-icon size="22">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete File</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-card-actions>
        </v-card>
    </v-card>
</template>

<script>

import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";
import {UuidUtils} from "@/common/UuidUtils";

export default {
    name: "p-setup-data",
    components: {},
    data: () => ({
        //name: 'image.png', size: 568609, created: 1645618498, updated: 1645618498
        headers: [
            {text: 'Name', sortable: true, value: 'name', class: "white blue--text", color: "red"},
            {text: 'Size', sortable: true, value: 'size', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'10%', align:'end'}
        ],
        model:null,
        files:[],
        working:false,
    }),
    created() {},
    methods:{
        getSize(bites){
            return UuidUtils.formatSizeUnits(bites)
        },
        onPressDelete(file){
            this.$confirm("Are you sure?")
            .then(() => {
                PackageStoreUtils.deletePackageFile(this.model.id, file.name)
                .then(() => {
                    this.reloadList();
                    this.$notify({title: 'File successfully deleted!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.$notify({title: 'File delete failed!', text: error, type: "error"});
                })
            }).catch(() => {})
        },
        onPressPreview(file){
            //console.log('onPressPreview: ', file.name)
            this.$emit('show-p-file-preview-popup', this.model.id, file.name)
        },
        setModel(model){
            this.model = model.copy()
            this.reloadList();
        },
        reloadList(){
            this.working = true
            this.files = []
            PackageStoreUtils.fethPackageContent(this.model.id)
            .then((data) => {
                this.working = false
                this.files = JSON.parse(data) || [];
            }).catch((error) => {
                console.log(error);
                this.working = false
            })
        },
        validate(){
            return this.files.find(e=>e.name == 'data.json') != undefined
        },
        onPressImportJson(){
            window.addEventListener('focus', () => {
            }, { once: false })
            this.$refs.uploaderJson.click()
        },
        onPressImportFile(){
            window.addEventListener('focus', () => {
            }, { once: false })
            this.$refs.uploaderFile.click()
        },
        onFileChangedFile(e) {
            let file = e.target.files[0]
            if (file == undefined){return}

            let uploadData = {}
            uploadData.name = file.name
            uploadData.packageId = this.model.id
            uploadData.content = ''

            let self = this;
            if (file.name.includes('.png') || file.name.includes('.jpeg') ){
                var reader = new FileReader();
                reader.onload = function(e) {
                    uploadData.content = e.target.result.split(',')[1]
                    self.uploadFile(uploadData);
                };
                reader.onerror = function(error) {
                    console.log(error);
                };
                reader.readAsDataURL(file);
                return;
            }
            if (file.name.includes('.xml')){
                file.text().then((data)=>{
                    uploadData.content = btoa(unescape(encodeURIComponent(data)))
                    this.uploadFile(uploadData);
                }).catch((error) => {console.log(error)})
                return;
            }
            if (file.name.includes('.json')){
                if (file.name == 'data.json'){
                    this.$notify({title: 'data.json its reserved name', text: '', type: "error"});
                    return;
                }
                file.text().then((data)=>{
                    uploadData.content = btoa(data)
                    this.uploadFile(uploadData);
                }).catch(() => {})
                return;
            }
            this.$notify({title: 'invalid file format', text: '', type: "error"});
        },
        uploadFile(data){
            this.working = true
            PackageStoreUtils.uploadPackageFile(data)
            .then(() => {
                this.working = false
                this.reloadList();
                this.$notify({title: 'File successfully uploaded!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.working = false
                this.$notify({title: 'File upload failed!', text: error, type: "error"});
            })
        },
        onFileChangedJson(e) {
            this.selectedFile = e.target.files[0]
            this.selectedFile.text()
            .then((data)=>{
                let parsedData = JSON.parse(data);
                if (Object.hasOwn(parsedData, 'reward') || Object.hasOwn(parsedData, 'products')) {
                    let uploadData = {}
                    uploadData.name = 'data.json'
                    uploadData.packageId = this.model.id
                    uploadData.content = btoa(JSON.stringify({
                        id: this.model.id,
                        data: parsedData,
                        kind: this.model.packageType.id
                    }))
                    this.uploadFile(uploadData)
                }else{
                    this.$notify({title: 'Invalid rewards file!', text: "", type: "error"});
                }
                // if (Object.hasOwn(parsedData, 'reward')){
                //     let reward = parsedData['reward'];
                //     if (Object.hasOwn(reward, 'money') && Object.hasOwn(reward, 'items') && Object.hasOwn(reward, 'packages')){
                //         let uploadData = {}
                //         uploadData.name = 'data.json'
                //         uploadData.packageId = this.model.id
                //         uploadData.content = btoa(JSON.stringify({id:this.model.id, data:parsedData, kind: this.model.packageType.id}))
                //         this.uploadFile(uploadData)
                //     }else{
                //         this.$notify({title: 'Invalid rewards file(money,items,packages)', text: "", type: "error"});
                //     }
                // }else{
                //     this.$notify({title: 'Invalid rewards file(reward)', text: "", type: "error"});
                // }
            }).catch((error) => {
                this.$notify({title: 'Json import failed!', text: error, type: "error"});
            })
        },
    },
    computed:{}
}
</script>

<style scoped>
</style>